<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/cleanEx-start')"></span>
    </div>
    <div class="title">请选择您的房型</div>
    <!-- <img class="prepay-img" src='../../assets/img/other/prepaid50.png'> -->
    <br>
		<div class="main clearfix">
			<div class="cell" @click="orderUpdate('house_type','1');orderUpdate('is_duplex','0','/cleanex-step2')">
				<img src="../../assets/img/clean/type/apartment.svg">
				<div>Apartment<br><span>电梯公寓</span></div>
			</div>

			<div class="cell" @click="orderUpdate('house_type','2');orderUpdate('is_duplex','0','/cleanex-step2')">
				<img src="../../assets/img/clean/type/unit.svg">
				<div>Unit<br><span>无电梯公寓</span></div>
			</div>

			<div class="cell" @click="orderUpdate('house_type','3');showModal = true">
				<img src="../../assets/img/clean/type/house.svg">
				<div>House<br><span>独立别墅</span></div>
			</div>

			<div class="cell" @click="orderUpdate('house_type','4');showModal = true">
				<img src="../../assets/img/clean/type/townhouse.svg">
				<div>Town House<br><span>联排别墅</span></div>
			</div>

			<div class="cell last" @click="orderUpdate('house_type','5');orderUpdate('is_duplex','0','/cleanex-step2')">
				<img src="../../assets/img/clean/type/studio.svg">
				<div>Studio<br><span>无客厅套房</span></div>
			</div>

			<div class="cell last" @click="orderUpdate('house_type','6');showModal = true">
				<img src="../../assets/img/clean/type/other.svg">
				<div>Other<br><span>其它</span></div>
			</div>
		</div>

    <transition name="fade">
      <v-modal v-if="showModal" @close="showModal = false">
        <div slot="body">

					<div class="modal-title">内部是否为复式结构</div>

					<div class="multilayer">
						<div class="option-btn" @click="orderUpdate('is_duplex','1');" v-bind:class="{ active: order.data.is_duplex == 1 }">复式</div>
						<div class="option-btn" @click="orderUpdate('is_duplex','0');" v-bind:class="{ active: order.data.is_duplex == 0 }">非复式</div>
					</div>


					<div class="info-box">
						<div v-show="order.data.is_duplex === '1'">
							<v-counter @plus="plus" @minus="minus" :num='order.data.duplex_floor' type='duplex_floor'>
								<span slot="label">房屋共几层</span>
							</v-counter>
						</div>
						<div v-show="order.data.is_duplex === '3'">
							<div class="info">如果您的房子有2层或更高，请选复式</div>
						</div>
						<div v-show="order.data.is_duplex === '0'">
							<div class="info">非复式，房屋结构是单层的</div>
						</div>
					</div>

					<div class="btn-box">
						<div class="btn" @click="checkSubmit()"  :class="{ active: allFilled()}" >下一步</div>
					</div>
				</div>
      </v-modal>
    </transition>
    <img :src="pixelURL('clean','huxing')" class="hide">
  </div>


</template>

<script>
export default {
  name: 'cleanEx-step1',
  data () {
    return {
			showModal: false,
      order:{
        service:'cleanEx',
        data:{
          token:0,
          type_id:"",
          address_name:"",
          address_phone:"",
          address_street:"",
          address_suburb:"",
          address_postcode:"",
          address_state:"NSW",
          address_unit: "",
          service_date:"",
          service_period:"",
          house_type:"",
          house_layout:"",
          is_carpet:3,
          carpet:1,
          parking:"",
          msg:"",
          floor:"",
          is_duplex:'0',
          duplex_floor:2,
          order_source:"3",
          coupon_id:"",
          coupon_title:"",
          couponLocked:"",
          couponValue:0,
        },
        temp:{
          isAM:'',
          isPM:'',
          isDate:''
        }
      }
    }
  },
  methods: {
    plus: function (res) {
			this.order.data.duplex_floor = this.order.data.duplex_floor+1;
			if(this.order.data.duplex_floor > 5){
				this.order.data.duplex_floor = 5;
			}
		},
    minus: function (res) {
			this.order.data.duplex_floor = this.order.data.duplex_floor-1;
			if(this.order.data.duplex_floor < 2){
				this.order.data.duplex_floor = 2;
			}
		},
    allFilled(){
      if(this.order.data.is_duplex !== '3'){
        return true;
      }
    },
    checkSubmit(){
      if(this.allFilled()){
          this.orderUpdateAll('/cleanex-step2');
      }
      else{
          alert('请填写楼层复式信息')
      }
    },
  },
  components: {
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "cleanEx"){
        this.order = localParsed;
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.multilayer{
	text-align:center;
	margin:20px 0;
}

.info-box{
	min-height:60px;
	padding-top:13px;
}

.info{
	font-weight:100;
	text-align:center;
	padding-top:4px;
}

.btn{
  width: 250px;
  height: 50px;
	margin-top:10px;
	background: #ddd;
	color:#666;
}
.btn.active{
  color:#fff;
	background: rgb(237,121,75);
	background: linear-gradient(90deg, #ff7444 0%,#fe9567 100%);
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}

.main{
  padding:0 30px 30px 30px;
}
.cell{
	float:left;
	width:50%;
	border-bottom:1px solid #DDD;
	box-sizing: border-box;
	height: 130px;
	text-align: center;
	cursor: pointer;
}
.cell:active{
	background: #eee;
}
.cell:nth-child(odd) {
	border-right:1px solid #DDD;
}
.cell.last{
	border-bottom:0;
  padding-top:10px;

}
.cell img{
	width:60px;
}

.cell div{
	margin-top:4px;
	color:#595D68;
  line-height:1.3;
  span{
    font-size:0.84em;
  }
}
.fade-enter {
  opacity: 0;
}

.fade-leave-active {
  opacity: 0;
}

.fade-enter .modal-container,
.fade-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.option-btn{
  border:2px solid #fe9567;
  border-radius:4px;
  min-width:68px;
	padding:0 8px;
  height:34px;
  line-height:34px;
  color:#ff7444;
  display:inline-block;
  margin:0 4px;
	text-align:center;
}

.option-btn.active{
  border:2px solid #fe9567;
  border-radius:4px;
  width:68px;
  height:34px;
  line-height:34px;
  background-color:#fe9567;
  color:#fff;
  display:inline-block;
  margin:0 4px;
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}


.prepay-img{
  width:100%;
}

</style>



// WEBPACK FOOTER //
// src/pages/cleanEx/step1.vue